import { ComponentClass } from 'react';
export { ComponentClass };
import { createLazyComponent, LazyModule } from 'owa-bundling';
import { FeedbackFormProps } from './components/FeedbackForm';
import { FeedbackRibbonProps } from './components/FeedbackRibbon';
import { FeedbackDialogParams, FeedbackCategory } from './components/InlineFeedbackDialog';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FeedbackForm", webpackPrefetch: true */ './lazyIndex')
);

export let FeedbackForm = createLazyComponent(lazyModule, m => m.FeedbackForm);
export let FeedbackRibbon = createLazyComponent(lazyModule, m => m.FeedbackRibbon);
export let NewConsumerRecruitmentForm = createLazyComponent(
    lazyModule,
    m => m.NewConsumerRecruitmentForm
);
export { FeedbackFormProps, FeedbackRibbonProps, FeedbackDialogParams, FeedbackCategory };
